// extracted by mini-css-extract-plugin
module.exports = {"c-label":"invitationDialout_c-label__3BYtI","c-button":"invitationDialout_c-button__2nCNH","c-dialouts":"invitationDialout_c-dialouts__38EwD"};